<div class="info-tree">
  <mat-tree [dataSource]="data" [treeControl]="tc">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li>
        <div>
          <span *ngIf="keyValueMode" class="property-name">{{node.name}}</span>
          <span class="property-value" [title]="node.value">{{node.value}}</span>
        </div>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li>
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle>
            <mat-icon>
              {{tc.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button> {{node.name}}
        </div>
        <ul [hidden]="!tc.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>
